import React from 'react'

import { Button, ButtonProps } from '@octane/spark'

const FormSubmissionButton = ({ children, ...props }: ButtonProps) => (
    <Button {...props}>{children ?? 'Advance to Instant Decision'}</Button>
)

export default FormSubmissionButton
